var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCookie = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 53,
  height: 59,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.74.1800144c14.2158095 0 25.74 11.5241905 25.74 25.74 0 1.0360675-.061213 2.0578379-.1802196 3.061892L51.21 28.9800144c-2.7431602 0-5.114059 1.5938407-6.2360381 3.906328-.4285543-.0829063-.8711872-.126328-1.3239619-.126328-2.9162815 0-5.4118319 1.8013638-6.4336815 4.3523262C33.7051112 37.4510668 30.96 40.4099631 30.96 44.0100144c0 .1628797.0056192.3244471.0159482.4845169C29.2224192 45.7519932 28.08 47.8075906 28.08 50.1300144c0 .483778.0495718.9559779.14397 1.4118507-.8161443.0780467-1.6453739.1181493-2.48397.1181493-14.2158095 0-25.74-11.5241905-25.74-25.74 0-14.2158095 11.5241905-25.74 25.74-25.74z",
  fill: "#EFA259"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5.6476602 10.4610852c0-2.458692 1.992726-4.45248 4.453416-4.45248 2.459736 0 4.453434 1.993788 4.453434 4.45248 0 2.46177-1.993698 4.453434-4.453434 4.453434-2.46069 0-4.453416-1.991664-4.453416-4.453434M2.1600018 21.939372c0-1.69209 1.369818-3.060846 3.060828-3.060846 1.690164 0 3.06189 1.368756 3.06189 3.060846 0 1.691118-1.371726 3.061872-3.06189 3.061872-1.69101 0-3.060828-1.370754-3.060828-3.061872M38.5727022 24.1351434c0-1.229328.99738-2.226708 2.225664-2.226708 1.231452 0 2.22885.99738 2.22885 2.226708 0 1.229346-.997398 2.226726-2.22885 2.226726-1.228284 0-2.225664-.99738-2.225664-2.226726M28.8332784 3.61836c0-1.999026 1.620396-3.61836 3.619422-3.61836 1.998918 0 3.61827 1.619334 3.61827 3.61836 0 1.998918-1.619352 3.619314-3.61827 3.619314-1.999026 0-3.619422-1.620396-3.619422-3.619314M8.7443982 33.042348c0-2.614698 2.115522-4.733316 4.730112-4.733316 2.612682 0 4.731192 2.118618 4.731192 4.733316 0 2.612592-2.11851 4.73013-4.731192 4.73013-2.61459 0-4.730112-2.117538-4.730112-4.73013M35.0259084 13.6401768c0-2.613636 2.116494-4.732128 4.731192-4.732128 2.61153 0 4.730112 2.118492 4.730112 4.732128 0 2.614698-2.118582 4.731192-4.730112 4.731192-2.614698 0-4.731192-2.116494-4.731192-4.731192M19.5820668 14.9659362c0-1.692198 1.368774-3.060828 3.060954-3.060828 1.690038 0 3.060828 1.36863 3.060828 3.060828 0 1.691118-1.37079 3.060828-3.060828 3.060828-1.69218 0-3.060954-1.36971-3.060954-3.060828M12.9008682 47.9094696c0-1.999026 1.619334-3.619314 3.61836-3.619314 1.9989 0 3.616218 1.620288 3.616218 3.619314 0 1.996884-1.617318 3.617298-3.616218 3.617298-1.999026 0-3.61836-1.620414-3.61836-3.617298",
  fill: "#873F21"
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 34.83,
  cy: 52.4700144,
  r: 2.43
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#873F21",
  cx: 41.04,
  cy: 50.0400144,
  r: 1.62
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 50.4,
  cy: 33.1200144,
  r: 1.62
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#EFA259",
  cx: 41.31,
  cy: 57.5100144,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  fill: "#873F21",
  cx: 28.89,
  cy: 29.4300144,
  r: 6.93
}))));
export default SvgCookie;